import React from "react";
import { Card, Row, Col, Form } from "react-bootstrap";
import "./Transaction_History_card.css";

function Transaction_History_card({ detail, time, balance, type }) {
  return (
    <div className="transaction_history_card">
      <Card className="history_card">
        {/* Header */}
        <Card.Header className="history_card_header">
          {detail}
        </Card.Header>

        {/* Body */}
        <Card.Body className="history_card_body">

          <Row className="history_row header_row me-0 ms-0">
            <Col>Detail</Col>
            <Col className="text-end">{detail}</Col>
          </Row>

          <Row className="history_row me-0 ms-0">
            <Col>Time</Col>
            <Col className="text-end">{time}</Col>
          </Row>

          <Row className="history_row me-0 ms-0">
            <Col>Balance</Col>
            <Col className={`text-end ${type === "in" ? "moved_in_amount" : "moved_out_amount"}`}>
              ₹{balance}
            </Col>
          </Row>

          <div className="history_empty_box">
            <Form.Group>
              <Form.Control as="textarea" rows={2} />
            </Form.Group>
          </div>

        </Card.Body>
      </Card>
    </div>
  );
}

export default Transaction_History_card;